import React, { useEffect, useState } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { authActions } from "./modules/Auth/_redux/authActions";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./modules/Auth";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { getCredentials, refreshTokens } from "../api/auth/index";
import ErrorsPage from "./modules/Errors/ErrorsPage";
import { logError } from "../utils/logger";
import { LayoutSplashScreen } from "../_metronic/layout";

export function Routes() {
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const isLogged = useSelector(
		(store) => store.authentication?.loggedIn,
		shallowEqual
	);

	// Checking wether we have credentials in cookies before going to login
	useEffect(() => {
		function fetchMyCredentials() {
			setLoading(true);
			setTimeout(async () => {
				try {
					const response = await getCredentials();
					if (response)
						dispatch(authActions.loginActionSuccess(response?.data));
					setLoading(false);
				} catch (error) {
					logError({
						error,
						customMessage: "Cannot get credentials, please login.",
					});
					dispatch(authActions.logoutAction());
				}
				setLoading(false);
			}, 1000);
		}
		fetchMyCredentials();
	}, [dispatch]);

	// Refresh interval every 15 minutes if logged
	useEffect(() => {
		if (isLogged) {
			const interval = setInterval(async () => {
				try {
					await refreshTokens();
				} catch (error) {
					logError({ error, customMessage: "Cannot refresh tokens." });
					dispatch(authActions.logoutAction());
				}
			}, 900000);
			return () => clearInterval(interval);
		}
	}, [dispatch, isLogged]);

	return loading ? (
		<LayoutSplashScreen />
	) : (
		<Switch>
			<Route path="/error" component={ErrorsPage} />
			<Route path="/logout" component={Logout} />

			{!isLogged ? (
				<Route path="/auth" component={AuthPage} />
			) : (
				<Redirect from="/auth" to="/" />
			)}

			{isLogged ? (
				<Route
					path="/"
					render={() => (
						<Layout>
							<BasePage />
						</Layout>
					)}
				/>
			) : (
				<Redirect to="/auth/login" />
			)}
		</Switch>
	);
}
